import declare from "dojo/_base/declare";
import HomePageUtil from "./util";
import NewItemPaneForm from "./NewItemPaneForm";

const NewFormulatedProductPaneForm = declare(NewItemPaneForm, {
	allowedPaneIds: [
		"HomeFoodHierarchy",
		"HomeFoodLabel",
		"HomeFoodRecipe",
		"HomeFoodSample",
		"HomeFoodSKU",
		"HomeFoodSupplierItem",
		"HomeFoodTest",
		"HomeFoodTestRun",
		"HomeFormulatedMaterialHierarchy",
		"HomeFormulatedMaterialLabel",
		"HomeFormulatedMaterialRecipe",
		"HomeFormulatedMaterialSample",
		"HomeFormulatedMaterialSupplierItem",
		"HomeFormulatedMaterialTest",
		"HomeFormulatedMaterialTestRun",
		"HomeSupplierRequest",
	],

	/**
	 * @override
	 * Return context types of views that are allowed for selection in this form
	 */
	getContextTypes(): string[] {
		return [];
	},

	/**
	 * @override
	 * Return domain type of views that are allowed for selection in this form
	 */
	getDomainType(): string {
		return "FormulatedProduct";
	},
});

export = NewFormulatedProductPaneForm;